import { call, put, takeEvery } from 'redux-saga/effects'
import { OK } from '@/constants/utils'
import partnersApi from '@/apis/partners'
import { fetchExpertsProspects } from '@/store/expertsList'

function* requestExpertsProspects() {
  try {
    const { status, json } = yield call(partnersApi.getExpertsProspects)

    if (status === OK) {
      const array = Array.isArray(json.result) ? json.result : []

      const items = array.reduce((acc, expert) => {
        if (expert?.expert_id != null) acc[expert.expert_id] = expert
        return acc
      }, {})

      yield put(fetchExpertsProspects.fulfilled({ items }))
    } else {
      throw new Error("Experts list couldn't be loaded")
    }
  } catch (error) {
    yield put(fetchExpertsProspects.rejected({ error: error?.message }))
  }
}

export function* watchExpertsListRequests() {
  yield takeEvery(fetchExpertsProspects.pending, requestExpertsProspects)
}
